/** Видимые тексты контрола аккаунта — буквально из Figma. */
export const ACCOUNT_TEXTS = {
  loginLabel: 'Войти',
  hintTitle: 'В Личном кабинете вы сможете:',
  hintItems: [
    'Следить за изменением цен на интересные вам отели и направления',
    'Хранить всю историю заказов и документы по ним',
    'Копить скидку на следующие поездки',
    'Управлять настройками рассылок',
  ],
} as const;
